import {Flex, Text} from "rebass";
import React from "react";
import {HomeIcon} from "./Icons/HomeIcon";

export const LabeledText = (props) => {
    return (
        <Flex>
            <Text fontWeight="bold" color="darkBlue" fontSize={props.fontSize | 1}>
                {props.label}
            </Text>
            <Text fontWeight="bold" color="secondary" fontSize={props.fontSize | 1} paddingLeft={props.paddingLeft} paddingRight={props.paddingRight}>
                {props.value}
            </Text>
        </Flex>
    )
}

export const HomeActivationText = (props) => {
    return (
        <Flex>
            <HomeIcon />
            <Text fontWeight="bold" color="darkBlue" fontSize={props.fontSize | 1}>
                {props.home_activation_code}
            </Text>
        </Flex>
    )
}
